import { Color, Flex, Icon, Spacing, Tag, Text, Tooltip } from '@billy/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useIsTruncated } from '../../../../../../hooks'
import * as Styled from './styles'

interface TransactionsTableDescriptionCellProps {
  value: string
  voided?: boolean
}

export const TransactionsTableDescriptionCell = ({ value, voided }: TransactionsTableDescriptionCellProps) => {
  const { t } = useTranslation()
  const [textRef, isTruncated] = useIsTruncated(value)

  const textElement = (
    <Text color={voided ? Color.Grey300 : undefined} ref={textRef} truncate>
      {value}
    </Text>
  )

  return (
    <Flex alignItems="center" gap={Spacing.S8} justifyContent="space-between" width="100%">
      <Styled.TransactionsTableDescriptionCellTextWrapper>
        {isTruncated ? (
          <Tooltip label={value} placement="top">
            {textElement}
          </Tooltip>
        ) : (
          textElement
        )}
      </Styled.TransactionsTableDescriptionCellTextWrapper>

      {voided && (
        <Tag color="neutral" type="subtle">
          <Icon icon="circleSlash" />
          {t('transactions.table.voided')}
        </Tag>
      )}
    </Flex>
  )
}
